<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/home">Home</a></li>
                <li>About Us</li>
            </ul>
            <h2>About Us</h2>
        </div>
    </div>
    <div class="shape9"><img src="images/shape8.svg" alt="image"></div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="about-content">
                    <h2 class="text-center">About Success Institute</h2>
                    <p class="justify-content text-center">Unlock Your Medical Future at Success Paramedical Institute!
                        <br>Our
                        comprehensive paramedical
                        courses prepare you for the evolving demands of the industry. Skilled faculty guide you every
                        step of the way, combining theory and hands-on training. Surat's premier institute for medical
                        excellence, we equip aspiring professionals with knowledge and skills for success. Experience
                        personal growth, professionalism, and empathy as you become a compassionate healthcare provider.
                        Join us today and embark on a transformative journey towards a fulfilling career in medicine!
                    </p>
                    <ul class="features-list">
                        <li><span><i class="fa-solid fa-circle-check"></i> Experienced Intellectual</span></li>
                        <li><span><i class="fa-solid fa-circle-check"></i> Academic Excellence</span></li>
                        <li><span><i class="fa-solid fa-circle-check"></i> Modern Facilities to help you succeed</span>
                        </li>
                        <li><span><i class="fa-solid fa-circle-check"></i> Wide Range of Courses</span></li>
                        <li><span><i class="fa-solid fa-circle-check"></i> Get Global Opportunities</span></li>
                        <li><span><i class="fa-solid fa-circle-check"></i> Career-Oriented Training</span></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="shape1"><img src="images/shape1.png" alt="image"></div>
    <div class="shape3"><img src="images/shape3.png" alt="image"></div>
    <div class="shape4"><img src="images/shape4.png" alt="image"></div>
</div>

<!-- <div class="container mt-2 mb-5">
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div class="text-center">
                <img src="images/nirav-soni.jpg" class="award-img" alt="Award Image">
                <div class="card-body">
                    <p class="mb-1 fw-bold mt-3">
                        Success Institute is Awarded for Running Best Education System in Surat by
                        Divya Tripasya - 2023
                    </p>
                    <p class="mb-0">
                        Awarded by: Mr. Nirav Soni at Gujarati Gaurav Award - 2023
                    </p>
                </div>
            </div>
        </div>
    </div>
</div> -->

<app-features-style-two></app-features-style-two>

<div class="section-title mb-2 mt-3">
    <h2>Success Institute at a Glance in Surat !</h2>
</div>

<div class="bg-fffaf3">
    <app-funfacts-style-one></app-funfacts-style-one>
</div>

<div class="container my-5">
    <div class="row align-items-center border-bottom py-4">
        <div class="col-md-2 text-center">
            <p class="fw-bold my-2"> Our Mission </p>
        </div>
        <div class="col-md-10 text-center">
            <p>
                To propel students towards a Fast-Growing Medical Institute in Surat and secure their Future.
                Our Mission is to provide Exceptional Education, Dynamic Training, and Unmatched Support.
            </p>
        </div>
    </div>
    <div class="row align-items-cente   r border-bottom py-4">
        <div class="col-md-2 text-center">
            <p class="fw-bold my-2"> Our Vision </p>
        </div>
        <div class="col-md-10 text-center">
            <p>
                Our vision is to be a leading institution in the medical field, driving both the growth of our
                institute
                and the growth of our students. We aim to create a dynamic learning environment that fosters innovation,
                research, and collaboration, empowering students to become outstanding healthcare professionals.
                By providing comprehensive education, cutting-edge resources, and ample opportunities for personal
                and professional development, we envision our students thriving and making a positive impact in the
                healthcare industry and beyond.
            </p>
        </div>
    </div>
</div>